module.exports = __webpack_public_path__ + "img/zoe.9f8dba2f.png";